<template>
  <my-dialog
    @hideMask="$emit('update:forbiddenStartUsingDialogFlag', false)"
    :dialogFlag="forbiddenStartUsingDialogFlag"
    width="400px"
    p_lr="0"
    borderRadius="8px"
    :hideMaskFlag="false"
    :clickMaskForHide="true"
  >
    <div class="dialog_container">
      <div class="dialog_container_header">
        <h3 class="header_title">{{ headerTitle }}</h3>
        <div class="close_btn" @click="$emit('update:forbiddenStartUsingDialogFlag', false)">
          <img src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202110/322b44f4a1e34d8cb527d1e033ec659b.png" alt="关闭">
        </div>
      </div>
      <div class="dialog_container_body" :style="{ paddingTop: forbiddenStartUsingDialogType === 'startusing' ? '20px' : '40px' }">
        <div class="icon_image">
          <img :src="forbiddenStartUsingDialogType === 'forbidden' ? require('../../../../assets/img/organizationalManagement/forbidden.png') : require('../../../../assets/img/organizationalManagement/startusing.png')" :alt="forbiddenStartUsingDialogType === 'forbidden' ? '禁用' : '启用'">
        </div>
        <div class="startusing_box" v-if="forbiddenStartUsingDialogType === 'startusing'">
          <h3>请选择生效日期</h3>
          <div class="date_picker">
            <a-range-picker
              :placeholder="rangePicker"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              separator="至"
              v-model="momentDate"
            >
              <a-icon slot="suffixIcon" type="calendar" />
            </a-range-picker>
          </div>
        </div>
        <p class="forbidden_title" v-if="forbiddenStartUsingDialogType === 'forbidden'">是否确认要禁用当前学校？</p>
      </div>
      <div class="dialog_container_footer">
        <div class="cancel_btn" @click="$emit('update:forbiddenStartUsingDialogFlag', false)">取消</div>
        <div class="confirm_btn" @click="handleConfirm">确定</div>
      </div>
    </div>
  </my-dialog>
</template>

<script>
export default {
  name: 'forbiddenStartUsing',
  components: {
    'my-dialog': () => import('@/components/my_dialog')
  },
  data () {
    return {
      rangePicker: ['开始日期', '结束日期'],
      momentDate: []
    }
  },
  props: {
    forbiddenStartUsingDialogFlag: {
      type: Boolean,
      default: false
    },
    forbiddenStartUsingDialogType: {
      type: String,
      default: ''
    },
    forbiddenStartUsingDialogSchoolCode: {
      type: String | Number,
      default: ''
    }
  },
  computed: {
    headerTitle: function () {
      let res = ''
      switch (this.forbiddenStartUsingDialogType) {
        case 'startusing':
          res = '启用'
          break
        case 'forbidden':
          res = '禁用'
          break
      }
      return res
    }
  },
  methods: {
    async handleConfirm () {
      try {
        const params = {
          schoolCode: this.forbiddenStartUsingDialogSchoolCode
        }
        if (this.forbiddenStartUsingDialogType === 'startusing') {
          if (!this.momentDate.length) return this.$message.error('请选择生效日期')
          Object.assign(params, {
            status: 1,
            openingDate: this.momentDate[0],
            expiredDate: this.momentDate[1]
          })
        } else {
          Object.assign(params, {
            status: 2
          })
        }
        const result = await this.$http.schoolUpdateStatus(params)
        if (result.code !== 200) return this.$message.error(result.msg)
        this.$message.success('操作成功')
        this.momentDate = []
        this.$emit('update:forbiddenStartUsingDialogFlag', false)
        this.$emit('getSchoolList')
      } catch (err) {
        console.log(err)
      }
      console.log('handleConfirm')
    }
  }
}
</script>

<style lang="scss" scoped>
  .dialog_container {
    .dialog_container_header {
      width: 100%;
      height: 60px;
      border-radius: 8px 8px 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 30px;
      border-bottom: 2px solid #EAEAEA;
      .header_title {
        font-size: 16px;
        font-weight: 500;
        color: #1E2228;
      }
      .close_btn {
        width: 12px;
        height: 12px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
    .dialog_container_body {
      width: 100%;
      height: 253px;
      padding-top: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .icon_image {
        width: 120px;
        height: 120px;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .startusing_box {
        display: flex;
        flex-direction: column;
        align-items: center;
        h3 {
          font-size: 16px;
          font-weight: 600;
          color: #0C0B22;
          margin-top: 16px;
        }
        .date_picker {
          margin-top: 16px;
        }
      }
      .forbidden_title {
        font-size: 16px;
        color: #0C0B22;
        margin-top: 20px;
      }
    }
    .dialog_container_footer {
      width: 100%;
      height: auto;
      padding: 20px 0;
      border-top: 2px solid #EAEAEA;
      display: flex;
      justify-content: center;
      .cancel_btn,
      .confirm_btn {
        width: 96px;
        height: 40px;
        border-radius: 4px;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        user-select: none;
      }
      .cancel_btn {
        border: 1px solid #5F60D3;
        color: #5F60D3;
        margin-right: 16px;
        &:hover {
          background-color: #F5F5F5;
        }
        &:active {
          background-color: #FFF;
        }
      }
      .confirm_btn {
        background-color: #5F60D3;
        color: #FFF;
        &:hover {
          background-color: #40419c;
        }
        &:active {
          background-color: #5F60D3;
        }
      }
    }
  }
</style>